var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 602 471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#outer-glow-3);\n      }\n\n      .cls-2 {\n        filter: url(#outer-glow-1);\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-width: 2px;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-6 {\n        filter: url(#outer-glow-2);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 18,
    width: 567,
    height: 450
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.9 384.67 99.35 371.37 526.01 371.37 515.85 383.27 526.35 394.47 99.35 396.57 75.9 384.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.48,333.05s0-1.58,0-6.29c0-10.49,0-20.97,0-31.46l13.84-25.17,13.84,25.17v37.75s179.96-119.34,179.96-119.34c1.13-.97,9.32-7.73,20.77-6.29,7.68,.97,12.52,5.09,13.84,6.29,1.1,1,6.64,5.38,6.92,12.58,.02,.43,0,.77,0,6.29v6.29c0,10.49,0,20.97,0,31.46v24.97s-13.73-24.97-13.73-24.97h-.22s-13.73,24.97-13.73,24.97v-24.97s0-37.75,0-37.75l-179.96,119.34c-1.13,.97-9.32,7.73-20.77,6.29-7.68-.97-12.52-5.09-13.84-6.29-1.1-1-6.64-5.38-6.92-12.58-.02-.43,0-.77,0-6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M488.66,333.05s0-1.58,0-6.29c0-10.49,0-20.97,0-31.46l-13.84-25.17-13.84,25.17v37.75s-179.96-119.34-179.96-119.34c-1.13-.97-9.32-7.73-20.77-6.29-7.68,.97-12.52,5.09-13.84,6.29-1.1,1-6.64,5.38-6.92,12.58-.02,.43,0,.77,0,6.29v6.29c0,10.49,0,20.97,0,31.46v24.97s13.73-24.97,13.73-24.97l13.95,24.97h0v-24.97s0-37.75,0-37.75l179.96,119.34c1.13,.97,9.32,7.73,20.77,6.29,7.68-.97,12.52-5.09,13.84-6.29,1.1-1,6.64-5.38,6.92-12.58,.02-.43,0-.77,0-6.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M502.55,207.41s9.45-6.49,12.6-6.49,12.6,6.49,12.6,6.49v163.61l-12.6,12.6-12.6-12.6V207.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.75,81.23c.18-1.23,.41-3.51,0-6.3-1.04-7.17-5.34-11.64-6.3-12.6-1.38-1.38-6.28-5.92-12.6-6.3-.27-.02-10.5,0-12.6,0h-88.2s-31.5,0-31.5,0v25.2h31.5s94.5,0,94.5,0l-50.17,50.17c-6.9,6.9-6.93,18.08-.07,25.02l50.24,50.8s0,0,0,0c0,0,12.6,25.21,12.6,25.21l12.57-25.21s.03,0,.03,0c0-6-3.97-10.27-6.3-12.6l-50.4-50.4c16.8-16.8,33.6-33.6,50.4-50.4,1.82-1.93,5.37-6.25,6.3-12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.85,56.02v25.2h19.59s5.38,0,5.38,0c3.26,.12,5.72,4.74,6.53,6.31,2.32,4.49,20.04,39.71,44.1,88.2l6.3,12.59c12.6,25.2,37.8,25.2,50.4,0l6.3-12.6c23.75-47.7,41.4-82.78,44.1-88.2,.72-1.45,3.07-6.18,6.3-6.3l25.2-12.6-24.97-12.59c-5.88,0-6.08,0-6.3,0-5.21,.17-9.54,3.76-12.6,6.3-2.39,1.98-5.3,5.08-12.6,18.9-2.76,5.22-4.89,9.61-6.3,12.6l-44.1,88.2-50.63-100.81c-7.3-13.82-10.21-16.92-12.6-18.9-3.06-2.54-7.39-6.13-12.6-6.3-.22,0-.42,0-6.3,0h-24.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.38,56.02h-31.5c-21,0-42,0-63,0-2.1,0-4.2,0-6.3,0-6.1,0-6.03-.02-6.3,0-6.32,.38-11.22,4.92-12.6,6.3-.96,.96-5.26,5.43-6.3,12.6-.41,2.79-.18,5.07,0,6.3,.93,6.35,4.48,10.67,6.3,12.6,16.8,16.8,33.6,33.6,50.4,50.4-16.8,16.8-33.6,33.6-50.4,50.4-1.82,1.93-5.37,6.25-6.3,12.6-.18,1.23-.41,3.51,0,6.3,1.04,7.17,5.34,11.64,6.3,12.6,1.38,1.38,6.28,5.92,12.6,6.3,.27,.02,.2,0,6.3,0,2.1,0,75.37,0,75.37,0v-25.2h-18.9s-56.47,0-56.47,0l50.24-50.8c6.86-6.94,6.83-18.12-.07-25.02l-50.17-50.17h94.5s6.3,0,6.3,0l25.2-12.6-25.2-12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.35,226.12c-1.04-7.17-5.34-11.64-6.3-12.6-1.38-1.38-6.28-5.92-12.6-6.3-.27-.02-.2,0-6.3,0h0s-31.5,0-31.5,0l-25.2,12.6,25.2,12.6h31.5s0,0,0,0l-113.29,75.6c-3.05,2.28-5.05,4.61-6.3,6.3-5.35,7.24-6.02,15.09-6.3,18.9-.24,3.26,0,5.71,0,6.3,0,23.1-.11,21-.11,44.1l12.6-6.3,12.6-6.3,.11-44.1,119.59-81.9s5.37-6.25,6.3-12.6c.18-1.23,.41-3.51,0-6.3Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.682ed212c3490324b8e68c684e78c831.svg";
export { ForwardRef as ReactComponent };